import { Module } from "../../Model/Module";
import { ModuleState, EInstrumentType } from "../../Model/ModuleState";
import React, { useState } from "react";
import "./PsrStatusComponent.css";

export type PsrStatusComponentProps = {
  instrumentType: EInstrumentType;
  psrModule: Module;
  moduleStateById: { [index: string]: ModuleState };
};

export default function PsrStatusComponent({
  instrumentType,
  psrModule,
  moduleStateById,
}: PsrStatusComponentProps) {
  const moduleState = moduleStateById[psrModule.identifier];
  const psrState = moduleState.psr;

  if (psrState == null) {
    throw new Error("Psr State is null");
  }

  const isCartesian = psrState.cartesianPosition != null;

  return (
    <div className="psr-status-container">
      <div className="psr-status-movement">
        <span>PSR:</span>
        <span>{psrState.status}</span>
      </div>
      <div className="psr-status-position">
        <span>{isCartesian ? "X:" : "T:"}</span>
        <span>
          {psrState.cartesianPosition?.x?.toFixed(2) ??
            psrState.cylindricalPosition?.t?.toFixed(2) ??
            0 + " "}
        </span>
        <span>{isCartesian ? "Y:" : "E:"}</span>
        <span>
          {psrState.cartesianPosition?.y?.toFixed(2) ??
            psrState.cylindricalPosition?.e?.toFixed(2) ??
            0 + " "}
        </span>
        <span>Z:</span>
        <span>
          {psrState.cartesianPosition?.z?.toFixed(2) ??
            psrState.cylindricalPosition?.z?.toFixed(2) ??
            0 + " "}
        </span>
      </div>
      <div className="psr-status-sensor">
        <span>Plate Sensor:</span>
        <span>{psrState.platePresenceSensor ? "On" : "Off"}</span>
      </div>
    </div>
  );
}
